import React from 'react';
import { useEffect, useState } from "react";

import { useNavigate, useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useSelector } from 'react-redux';
import { ApiDelete, ApiGet } from '../helper/API/ApiData';
import { getHeading } from '../utils/helper';
import { StringIfPlural } from 'react-i18next';


type GroupMemberSaving = {
    groupDetail: {
        isActive: boolean
    }
    id: string
}

type ListViewProps = {
    navigate_url: {
        create_url: string
        update_url: string
    }
    api_url: {
        delete_url: string
        list_url: string
    }
    title: string
    hiddenFields?: string[]
}

type List = {
    id: string
}

export const ListView = ({ api_url, navigate_url, title, hiddenFields = ['id', 'slug', 'groupDetail'] }: ListViewProps) => {
    const navigate = useNavigate()

    const [list, setList] = useState<List[]>([])

    useEffect(() => {

        ApiGet(api_url.list_url)
            .then((res: any) => {
                if (res && res.status === 200) {
                    if (res && res.data) {
                        setList(res.data)
                    }
                }
            })
    }, [])


    const handleUpdate = (itemId: string): void => {
        navigate(`${navigate_url.update_url}/${itemId}`)
    }

    const handleDelete = (itemId: string): void => {
        swal({
            title: "Are you sure?",
            text: "you want to delete SHG?",
            icon: "error",
            buttons: ["cancel", "ok"],
            dangerMode: true,
        }).then((result) => {
            if (result) {
                ApiDelete(`${api_url.delete_url}/${itemId}`, {})
                    .then((res: any) => {
                        if (res.status === 200) {
                            toast.success("Successfully deleted the shg")
                            setList(prevList => prevList.filter(item => item.id !== itemId))
                        }
                    })
                    .catch((error: any) => { return error })
            }
        })
    }

    const header = () => (

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xxl text-900 font-bold">{title}</span>
            <Button icon="pi pi-plus" outlined style={{ borderRadius: "50%" }} onClick={() => navigate(navigate_url.create_url)} />
        </div>
    );

    const actionBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={() => handleUpdate(rowData.id)} />
                <Button icon="pi pi-trash" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="danger" onClick={() => handleDelete(rowData.id)} />
            </React.Fragment>
        )
    };

    return (
        <DataTable value={list} header={header}>
            {list.length > 0 && Object.keys(list[0]).map((groupMemberSavingsField, index) => {
                if (!hiddenFields.some(field => field === groupMemberSavingsField)) {
                    return (
                        <Column style={{ width: "300px" }} key={groupMemberSavingsField} field={groupMemberSavingsField} header={getHeading(groupMemberSavingsField)}></Column>
                    )
                }
            })}
            <Column body={actionBodyTemplate} style={{ minWidth: '12rem' }} bodyStyle={{ textAlign: 'center' }}></Column>

        </DataTable>
    )
};